import { decimal, InferOutput, number, pipe, string, transform, union } from 'valibot'

export const StringOrNumberAsNumberSchema = union([
  pipe(string(), decimal(), transform(Number)),
  number(),
])

export type StringOrNumberAsNumber = InferOutput<typeof StringOrNumberAsNumberSchema>
